export const cancelSources = {
  getOrders: null,
  getSupplies: null,
};

export const cancelGetOrders = (message = 'Canceled') => {
  if (cancelSources.getOrders) {
    cancelSources.getOrders(message);
    cancelSources.getOrders = null;
  }

  if (cancelSources.getSupplies) {
    cancelSources.getSupplies(message);
    cancelSources.getSupplies = null;
  }
};
